import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import { getEnvByHostname } from 'config';
import { MirrorService } from 'services/MirrorService';

import { setXPrevUrl, setXRefererUrl } from 'api/httpClient';
import { TrackingApi } from 'api/TrackingApi';
import { setTrackingCookiesFromUrl } from 'helpers/analytics/trackingCookies';

import { RootApp } from './RootApp';

import 'context-filter-polyfill';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import 'styles/main.sass';
import 'globalthis/auto'; // globalthis polyfill

MirrorService.init();

const env = getEnvByHostname(window.location.hostname);

Sentry.init({
  dsn: 'https://9a057ed4e7510b795c58bfcda1e9b85e@o4506705060888576.ingest.us.sentry.io/4508890577240064',

  integrations: [Sentry.browserTracingIntegration()],
  ignoreErrors: [
    'Request aborted',
    'Network',
    'Failed to fetch',
    'Loading CSS chunk',
    'Load failed',
  ],

  release: process.env.REACT_APP_RELEASE_ID || 'test',
  environment: env,

  sampleRate: 0.001,
  tracesSampleRate: 0.001,

  sendDefaultPii: true,
  enabled: MirrorService.isProd,
});

/* Adds x-prev-url header to every request. Need for BE */
setXPrevUrl(document.referrer);
setXRefererUrl(window.location.href);

/** location.search part of url stored in cookies needed for BE and to get marketingParams from it */
setTrackingCookiesFromUrl();

TrackingApi.trackReactChunkLoadEnd();

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);

  root.render(<RootApp />);
}

// @ts-ignore
if (process.env.NODE_ENV === 'development' && module.hot) {
  // @ts-ignore
  module.hot.accept('./RootApp', render);
}
